export default __webpack_public_path__ + "static/media/Edi si A la apartament_115-min.d02f686b.jpg";